import { type AutoIncrementField } from '@/components/data-table/display/fields/Field';
import { type FieldRenderProps } from '@/components/data-table/display/fields/FieldRender';

export function AutoIncrementRender({ value }: FieldRenderProps<AutoIncrementField>) {
  return <p className="size-full truncate p-2 text-right">{value}</p>;
}
